import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { JsonControl, JsonControlItemCustomOptions } from '../model';

@Component({
  selector: 'jsonform-form-control-input',
  templateUrl: './form-control-input.component.html',
  styleUrls: ['./form-control-input.component.scss'],
  standalone: false,
})
export class FormControlInputComponent {
  @Input() public jsonControl!: JsonControl;
  @Input() public opciones: JsonControlItemCustomOptions[] = [];
  @Input() public control!: FormControl | any;
}
